
export class Agent {
  queue_name: string | null = null;
  interface: string | null = null;
  membername: string | null = null;
  state_interface: string = 'PJSIP/TELNYX';
  penalty: number = 0;
  available?: boolean = true;
  originalInterface?: string | null = null;
}